import { Checkbox, Space, Typography } from "antd";
import CustomAutoComplete from "./custom-auto-complete";
import ordersStorage from "../../../storages/orders.storage";
import { IOrderedItem } from "@drone-parts.garphild.pro/interfaces";

interface IShortNameProps {
  orderedItem: IOrderedItem;
}

function ShortName({ orderedItem }: IShortNameProps) {
  return (
    <>
      <Space>
        {orderedItem.itemUrl ?
          <Typography><a href={orderedItem.itemUrl}>{orderedItem.itemText}</a></Typography>
          : <Typography>{orderedItem.itemText}</Typography>
        }
      </Space>
      <hr/>
      <Space>
        <CustomAutoComplete
          value={orderedItem.shortName || ''}
          options={[
            ...(ordersStorage.shortNames),
          ]}
          onSelect={(value) => {
            ordersStorage.setItemField(orderedItem.orderId, orderedItem.marketplaceId!, orderedItem._id, value, 'shortName');
          }}
        />
      </Space>
      {!orderedItem.shortName && (
        <Space>
          <hr/>
          {orderedItem.possibleShortNames?.map((shortName, index) => {
            return (
              <Checkbox
                checked={orderedItem.shortName === shortName}
                onChange={(e) => {
                  ordersStorage.setItemField(orderedItem.orderId, orderedItem.marketplaceId!, orderedItem._id, shortName, 'shortName');
                }}
              >
                {shortName}
              </Checkbox>
            );
          })}
        </Space>
      )}
    </>
  );
}

export default ShortName;
